import * as moment from 'moment';

export const convertTimeStampToDate = (timeStampDate, dateFormat = '') => {
  if (!timeStampDate) return '';
  let parsedDate;
  if (dateFormat) {
    parsedDate = moment(timeStampDate, dateFormat, true);
  }
  if (!parsedDate || !parsedDate.isValid()) {
    if (!isNaN(timeStampDate)) {
      const num = Number(timeStampDate);
      parsedDate = num > 1e12 ? moment(num) : moment.unix(num);
    } else {
      parsedDate = moment(timeStampDate);
    }
  }
  if (!parsedDate.isValid()) return 'Invalid date';
  const hasTime =
    parsedDate.hours() || parsedDate.minutes() || timeStampDate.toString().length > 10;
  return parsedDate.format(hasTime ? 'Do MMM YYYY, h:mm a' : 'Do MMM YYYY');
};

export const formatTimepicker = (time, field) => {
  if (time) {
    let isShow24Hours =
      field.extraFieldSetting && field.extraFieldSetting.dateDisplayType === '24_HOURS';
    const format = isShow24Hours ? 'HH:mm' : 'h:mm a';
    return moment(time, format).format(format);
  } else {
    return '';
  }
};
